/* global jQuery */

jQuery(function($) {


  // FUNCTION TO ALLOW THROTTLED FUNCTION EXECUTION ON WINDOW RESIZE

    var waitForFinalEvent = (function () {

      var timers = {};

      return function (callback, ms, uniqueId) {

        if (!uniqueId) { uniqueId = "Don't call this twice without a uniqueId"; }

        if (timers[uniqueId]) { clearTimeout (timers[uniqueId]); }

        timers[uniqueId] = setTimeout(callback, ms);

      };

    })();


  // MOBILE NAV TOGGLES

    $('#mobile-menu-toggle').on('click',function(){

      $('#mobile-menu-toggle i').toggleClass('icon-menu icon-cancel active');

      $('#header-menu').slideToggle(200);

    });

    $('#mobile-search-toggle').on('click',function(){

      $('#mobile-search-toggle i').toggleClass('icon-search icon-cancel active');

      $('#mobile-search-form').slideToggle(200,function(){

        $('#mobile-search-text').focus();

      });

    });


  // EXPLORE UCL

    $('#institution-toggle').on('click',function(){

      $('#institution').slideToggle(200);

      $('#institution-toggle').toggleClass('active').blur();

    });


  // DESKTOP SEARCH TOGGLE

    function show_search_box() {

      $('#search-toggle').toggleClass('icon-search icon-cancel active');

      $('#header-menu li').animate( { opacity:0 } );

      var search_form_width = $('#header-nav-container').innerWidth() - 30 - $('#search-toggle').outerWidth();

      $('#search-form').animate(

        { width:search_form_width }, 200, 'swing',
        function(){

          $('#search-form').css({'width':'calc(100% - 46px)'});
          $('#search-text').focus();

        }

      );

      $('#search-toggle').data({ active:true });

    }

    function hide_search_box() {

      $('#search-toggle').toggleClass('icon-search icon-cancel active');

      $('#header-menu li').animate( { opacity:1 } );

      $('#search-text').blur();

      $('#search-form').animate({ width:0 }, 200, function(){ $('#search-toggle').blur() });

      $('#search-toggle').data({ active:false });

    }

    $('#search-toggle').on('click',function(e){

      if ( $('#search-toggle').data('active') !== true ) { show_search_box(); }
      else { hide_search_box(); }

    });

    $('#search-text').on('keyup', function(e){

      if (e.keyCode === 27) { hide_search_box(); }

    });


  // PUBLICATION FILTER DROPDOWN

    $('.publications-filter').on('change',function(){

      var publications_filter_active = $(this);

      if (publications_filter_active.val() !== '0') {

        $('.publications-filter').not(publications_filter_active).prop('selectedIndex',0).removeClass('is-active');

        publications_filter_active.addClass('is-active');

        $('#publications-filter-form').submit();

      } else {

        window.location = $('#publications-filter-form').attr('action');

      }

    });


  // COOKIE NOTICE CLOSE

    $('#cookie-notice-close').on('click',function(e){

      e.preventDefault();

      $('#cookie-notice').slideUp(200);

    });


  // DOWNLOAD AND OUTBOUND LINK TRACKING

    // Only track downloads for people who aren't logged in
    // and only attempt this when GA is present
    if ( !$('body').hasClass('logged-in') && typeof(ga) != 'undefined' ) {

      // Listen for a click on a link to download a file
      $('a[href$=".pdf"],a[href$=".zip"],a[href$=".doc"],a[href$=".docx"],a[href$=".xls"],a[href$=".xlsx"],a[href$=".ppt"],a[href$=".pptx"]').on('click', function (e) {

        // Stop the link from being visited immediately
        e.preventDefault();

        // Get the document URL
        var downloadURL = $(this).attr('href');

        // Send the event to Google Analytics
        ga( 'send', 'event', 'File download', downloadURL );

        // Visit the link after a very short pause
        setTimeout( function() { document.location.href = downloadURL; }, 100 );

      });

      // Listen for an external link click
      $('a:not([href="#"],a:not([href^="/"],[href^="' + location.protocol + '//' + location.hostname + '"])').on('click', function (e) {

        // Stop the link from being visited immediately
        e.preventDefault();

        // Get the external URL
        var externalURL = $(this).attr('href');

        // Send the event to Google Analytics
        ga( 'send', 'event', 'External link', externalURL );

        // Visit the link after a very short pause
        setTimeout( function() { document.location.href = externalURL; }, 100 );

      });

    }


  // SHARE POPUPS

    $('.share a').on('click',function(){

      // Track share in Google Analytics
      if (typeof ga !== 'undefined') {

        ga('send', 'event', 'Share', $(this).attr('class'), window.location.href);

      }

      // Popup a window if it's not an email link
      if (!$(this).hasClass('email')) {

        // Popup window settings
        var url = $(this).attr('href');
        var height = 285;
        if ($(this).hasClass('linkedin')) { height = 385; }

        // Pop the window
        var newwindow = window.open(url,'socialpop','height='+ height +',width=600');
        if (window.focus) { newwindow.focus(); }
        return false;

      }

    });


  // IMAGE ENHANCEMENT

    // Function to enhance images
    function images_enhance() {

      // Loop through all images with appropriate class
      $('.image-enhance').each(function() {

        // Set the jQuery object as a variable
        var $image_to_enhance = $(this);

        // Get the window width
        var window_width = $(window).innerWidth();

        // Only try this on sm screens and above
        if ( window_width > 767 ) {

          // Large
          if ( window_width > 1199 ) {

            var enhance_lg = $image_to_enhance.attr('data-enhance-lg');
            $image_to_enhance.css('background-image', enhance_lg);

          }

          // Medium
          else if ( window_width > 991 ) {

            var enhance_md = $image_to_enhance.attr('data-enhance-md');
            $image_to_enhance.css('background-image', enhance_md);

          }

          // Small
          else {

            var enhance_sm = $image_to_enhance.attr('data-enhance-sm');
            $image_to_enhance.css('background-image', enhance_sm);

          }

        }

      });

    }

    // Enhance images on window resize
    $(window).resize(function () {

        waitForFinalEvent(function(){

          images_enhance();

        }, 200, 'images-enhance');

    });

    // Enhance images on load
    images_enhance();


  // RESPONSIVE ASPECT RATIO

    // Find all blocks with responsive ratio class
    var allBlocks = $('.res-ratio');

    // Loop through each block
    allBlocks.each(function() {

      var block = $(this);

      block

        // Figure out the aspect ratio
        .data('aspectRatio', this.height / this.width)

        // Save it to a data attribute
        .data('blockParent', block.parent())

        // Remove the hard coded width/height
        .removeAttr('height')
        .removeAttr('width');

    });

    // Resize function
    function resizeNow() {

      // Resize all blocks according to their own aspect ratio
      allBlocks.each(function() {

        var block = $(this);

        var newWidth = block.data('blockParent').width();

        block
          .width(newWidth)
          .height(newWidth * block.data('aspectRatio'));

      });

    }

    // Trigger on window resize and kick off one resize to fix all blocks on page load
    $(window).resize(function () {

        waitForFinalEvent(function(){

          resizeNow();

        }, 200, 'responsive-ratio');

    });

    // Kick off one resize to fix all blocks on page load
    $(window).resize();



});
